import { useQuery } from "@tanstack/react-query";
// API
import API from "./Api";

export const fetchAllTaxiOrders = async () => {
  const res = await API.get("api/get-all-taxi-order");
  return res.data;
};

export default function useGetAllTaxiOrdersApi() {
  return useQuery({
    queryKey: ["AllTaxiOrders"],
    queryFn: () => fetchAllTaxiOrders(),
  });
}
